/** Articles per listing page (blog grid page size and initial server load). */
export const BLOG_ARTICLES_PAGE_SIZE = 15;